module.exports = __webpack_public_path__ + "media/images/logo-rouge-dc8ffa58f1cc59d5cb6cf60cf502b78c.svg";